import {Component, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {Store} from '@ngrx/store';
import {AppState} from '../../../../../../app/app.state';
import {App, AppId} from '../../../../../../shared/models/app';
import {ActivatedRoute} from '@angular/router';
import {UrlService} from '../../../../../../core/services/url.service';
import {AppsState} from '../../../../../../core/state/apps.state';
import {AppsService} from '../../../../../../core/services/apps.service';
import {ChildManageBaseComponent} from '../child-manage-base/child-manage-base.component';
import {ShadeToolsService} from '../../../../../../core/services/shade-tools.service';
import {SubnavComponent} from '../../../../../components/subnav/subnav.component';
import {FormsModule} from '@angular/forms';
import {NgClass} from '@angular/common';
import {SpinnerComponent} from '../../../../../components/spinner/spinner.component';
import {ConfigureOccupantTenantComponent} from './configure-occupant-tenant/configure-occupant-tenant.component';

@Component({
  selector: 'motn-configure-unit-prop-manager',
  templateUrl: './configure-unit-prop-manager.component.html',
  styleUrls: ['./configure-unit-prop-manager.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    SubnavComponent,
    FormsModule,
    NgClass,
    SpinnerComponent,
    ConfigureOccupantTenantComponent,
  ],
})
export class ConfigureUnitPropManagerComponent extends ChildManageBaseComponent implements OnInit, OnDestroy {
  app: App;
  appId: AppId;

  childApp: App;
  childAppId: AppId;

  editedName: boolean = false;

  submittingName: boolean = false;

  constructor(
    protected route: ActivatedRoute,
    protected appsService: AppsService,
    protected shadeTools: ShadeToolsService,
    protected store: Store<AppState>,
    protected urlService: UrlService,
  ) {
    super(appsService, urlService, shadeTools, route, store);
  }

  protected onInit(): void {
    this.appsSub = this.store.select('apps').subscribe(
      (data: AppsState) => {
        const app = data.apps.find((a) => {
          return a.ID === this.appId;
        });

        const childApp = data.apps.find((a) => {
          return a.ID === this.childAppId;
        });

        if (app) {
          this.app = JSON.parse(JSON.stringify(app));
        }

        if (childApp) {
          this.childApp = JSON.parse(JSON.stringify(childApp));
        }

        if (this.app) {
        }

        if (this.childApp) {
          this.updateTitle();
        }
      },
    );
  }

  submitName() {
    if (!this.editedName || this.submittingName) {
      return;
    }

    this.submittingName = true;

    this.appsService.patchAppName$(this.childAppId, this.childApp.Name).subscribe(
      (result) => {
        this.submittingName = false;
        this.editedName = false;
      },
      (error) => {
        this.submittingName = false;
        this.showError();
      },
    );
  }


  protected onDestroy() {

  }
}
